import {
  UpparbetadeKostnaderImportDateGranularity,
  UpparbetadeKostnaderImportLayout,
} from './upparbetade-kostnader-import.interface';

/** Hardcoded placeholders until question_budget_import_* keys exist in Språkhantering. */
export const UPPARBETADE_KOSTNADER_IMPORT_TEXT = {
  button: 'Importera upparbetade kostnader från Excel',
  title: 'Importera upparbetade kostnader från Excel',
  intro:
    'Ladda upp er egen kostnadsuppföljning (.xlsx). Vi läser av arbetsboken och föreslår var varje rad hör hemma för varje projektpart och öppet redovisningsår. Du väljer själv vilka rader som ska användas och om flera rader ska summeras. Inget sparas förrän du har granskat och godkänt förslaget.',
  fileLabel: 'Excel-fil',
  fileHelp: 'Filformat: .xlsx eller .xlsm. Max 10 MB.',
  analyze: 'Analysera fil',
  reasoningLabel: 'Analysnivå',
  reasoningHelp:
    'Lägre nivå är snabbare, högre nivå hanterar röriga filer bättre.',
  reasoningNone: 'Ingen (snabbast, kräver gpt-5.1 eller nyare)',
  reasoningMinimal: 'Minimal',
  reasoningLow: 'Låg',
  reasoningMedium: 'Medel',
  reasoningHigh: 'Hög (långsammast)',
  modelLabel: 'AI-modell',
  modelHelp: 'Vilken Foundry-modell analysen ska köras mot.',
  loading: 'Läser av arbetsboken …',
  loadingSlow:
    'Analysen tar längre tid än vanligt. Röriga eller stora filer kräver mer tid – du kan vänta eller avbryta och prova en lägre analysnivå.',
  elapsed: 'Tid',
  cancelAnalyze: 'Avbryt analysen',
  error:
    'Det gick inte att läsa filen. Kontrollera att den är en giltig Excel-fil och försök igen.',
  unitLabel: 'Beloppen i filen anges i',
  unitSek: 'Kronor (SEK)',
  unitTkr: 'Tusentals kronor (tkr)',
  unitMsek: 'Miljoner kronor (MSEK)',
  unitHelp:
    'Kontrollera enheten – fel enhet ger tusen gånger för höga eller låga belopp.',
  includePart: 'Använd värden för denna projektpart',
  noValues: 'Inga värden hittades för denna projektpart.',
  current: 'Nuvarande',
  imported: 'Importerat',
  confidenceHigh: 'Hög konfidens',
  confidenceMedium: 'Medel konfidens',
  confidenceLow: 'Låg konfidens',
  source: 'Källa',
  unmatchedTitle: 'Delar av filen kunde inte kopplas',
  apply: 'Använd värden',
  cancel: 'Avbryt',
  chooseOther: 'Välj en annan fil',
  koordinator: 'Koordinator',
  kostnader: 'Upparbetade kostnader',
  rowsTitle: 'Rader i filen',
  rowsHelp:
    'Välj var varje rad ska hamna. Rader du placerar på samma plats summeras. Rader som du inte vill använda sätter du på "Importera inte".',
  rowsLabel: 'Rad',
  rowsSource: 'Källa',
  rowsSlot: 'Placera i',
  rowsSuggested: 'Analysen föreslog',
  rowsSummed: 'Summeras med andra rader på samma plats',
  rowsIgnore: 'Importera inte',
  orgnr: 'Org.nr',
  preprocessingLabel: 'Förbehandla filen (filtrera på redovisningsperiod)',
  preprocessingHelp:
    'Vi läser av filens struktur, tar bort rader utanför perioden och summerar resten innan analysen. Snabbare och säkrare för stora transaktionslistor; stäng av om resultatet ser fel ut.',
  debugLabel: 'Visa felsökningsinformation',
  summaryRows: 'Rader inom perioden',
  summaryDate: 'Datum från',
  summarySheetsSkipped: 'Blad som hoppats över',
  reconciliationInFile: 'I filen',
  reconciliationInPeriod: 'Inom perioden',
  reconciliationExcluded: 'Utanför perioden',
  reconciliationUnmatched: 'Ej kategoriserat',
  excludedTitle: 'Rader som inte räknats med',
  excludedWorkbookTitle: 'Rader som inte kunde kopplas till en projektpart',
  excludedSource: 'Källa',
  excludedDate: 'Datum',
  excludedLabel: 'Beskrivning',
  excludedAmount: 'Belopp',
  excludedReason: 'Orsak',
  reasonOutsidePeriod: 'Utanför redovisningsperioden',
  reasonUnmatchedCategory: 'Kunde inte kategoriseras',
  reasonPartialOverlap: 'Delvis inom perioden – kontrollera',
  timingsPreprocessing: 'Förbehandling',
  timingsExtraction: 'Övrig analys',
  timingsServerTotal: 'Totalt på servern',
  timingsRoundTrip: 'Totalt inkl. överföring',
} as const;

export const LAYOUT_LABELS: Record<UpparbetadeKostnaderImportLayout, string> = {
  ledger: 'Transaktionslista',
  matrix: 'Periodmatris',
  summary: 'Sammanställning',
  unknown: 'Okänd struktur',
};

export const DATE_GRANULARITY_LABELS: Record<
  UpparbetadeKostnaderImportDateGranularity,
  string
> = {
  day: 'dag',
  week: 'vecka',
  month: 'månad',
  quarter: 'kvartal',
  year: 'år',
};

export const KOSTNADSSLAG_LABELS: Record<string, string> = {
  '1': 'Lönekostnader',
  '2': 'Utrustning, mark, byggnader',
  '3': 'Konsultkostnader, licenser',
  '4': 'Övriga direkta kostnader inkl. resor',
  '5': 'Indirekta kostnader',
};
